import React, {useCallback} from 'react'

const debounce = (fn, ms = 0) => {
    let timeoutId
    return function wrapper(...args) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => fn.apply(this, args), ms)
    }
}

const ConfigForm = ({ config, updateConfig }) => {
    const changeField = useCallback((name, value) => {
        updateConfig(name, value)
    }, [])
    const debounceChange = debounce(changeField, 500)

    return (
        <form>
            <div className="widget-form-group">
                <label>The element for initializing the widget</label>
                <div>
                    <input
                        name="$el"
                        type="text"
                        defaultValue={config.$el}
                        onChange={(e) => debounceChange(e.target.name, e.target.value)}
                        placeholder="The element for initializing the widget"
                    />
                </div>
            </div>
            <div className="widget-form-group">
                <label>Max list height</label>
                <div>
                    <input
                        name="listMaxHeight"
                        type="text"
                        defaultValue={config.listMaxHeight}
                        onChange={(e) => debounceChange(e.target.name, e.target.value)}
                        placeholder="Max list height"
                    />
                </div>
            </div>
            <div className="widget-form-group">
                <label>Locale</label>
                <div>
                    <input
                        name="locale"
                        type="text"
                        defaultValue={config.locale}
                        onChange={(e) => debounceChange(e.target.name, e.target.value)}
                        placeholder="Default is en"
                    />
                </div>
            </div>
            <div className="widget-form-group">
                <label>Market</label>
                <div>
                    <input
                        name="market"
                        type="text"
                        defaultValue={config.market}
                        onChange={(e) => debounceChange(e.target.name, e.target.value)}
                        placeholder="Default is en"
                    />
                </div>
            </div>
        </form>
    );
};

export default ConfigForm



// WEBPACK FOOTER //
// ./src/components/widgets/public-timeline/form.js